import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../modules/infra/i18n';

import { closeCancelPaymentModal } from './actions';
import Modal from '../../common/Modal';
import CancelPaymentButton from './cancelPaymentButton';

const CancelPaymentModal = ({ close }) => (
  <Modal title={t('common:cancel_payment_modal.title')} close={close} shouldCloseOnOverlayClick={false}>
    <div className="u-ph++ u-pv u-text-center">
      <CancelPaymentButton afterAction={close} />
    </div>
  </Modal>
);
CancelPaymentModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default compose(
  connect(state => ({
    display: state.payment.cancelPaymentModal,
  }), { close: closeCancelPaymentModal }),
  branch(
    props => !props.display,
    renderNothing
  ),
)(CancelPaymentModal);
